import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-bd63d8a4")

_pushScopeId("data-v-bd63d8a4")
const _hoisted_1 = { class: "df-middle t-center actions px-16" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Quick Play ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Buy")
const _hoisted_4 = { class: "f-md f-400 ml-10" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Sell")
const _hoisted_6 = { class: "f-md f-400 ml-10" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Buy: Profit if price rises, lose if price drops. Sell: Profit if price drops, lose if price rises. ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Pic = _resolveComponent("Pic")
  const _component_router_link = _resolveComponent("router-link")
  const _component_Icon = _resolveComponent("Icon")
  const _component_t = _resolveComponent("t")
  const _component_RealTimeQuote = _resolveComponent("RealTimeQuote")
  const _component_GuideContent = _resolveComponent("GuideContent")
  const _component_GuideTarget = _resolveComponent("GuideTarget")

  return (_openBlock(), _createBlock(_component_GuideTarget, { name: "create" }, {
    top: _withId(() => [
      _createVNode(_component_GuideContent, {
        "anchor-align": 70,
        abs: "",
        "anchor-position": "bottom",
        class: "mx-16",
        style: {"bottom":"90%"}
      }, {
        default: _withId(() => [
          _createVNode(_component_t, { path: "symbol_68" }, {
            default: _withId(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_router_link, {
          to: `/trade/fast?c=${_ctx.symbol?.code}`,
          custom: ""
        }, {
          default: _withId(({navigate}) => [
            _withDirectives(_createVNode("button", {
              onClick: navigate,
              class: "flex-1 line btn df-cross-center"
            }, [
              _createVNode(_component_Pic, {
                src: "trade/quickplay",
                width: "16",
                height: "16"
              }),
              _hoisted_2
            ], 8, ["onClick"]), [
              [_vShow, _ctx.list.includes(_ctx.symbol?.code)]
            ])
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_RealTimeQuote, { symbol: _ctx.symbol }, {
          default: _withId(({price, buy}) => [
            _createVNode(_component_router_link, {
              to: `/create/${_ctx.symbol && _ctx.symbol.code}/2`,
              custom: ""
            }, {
              default: _withId(({navigate}) => [
                _createVNode("button", {
                  class: "btn flex-2 success ml-16",
                  onClick: () => {
            navigate()
            // if (product?.specs?.length === 1 || !getSpeedAc('uuid')) {
            //   navigate()
            // } else {
            //   clickAlert()
            // }
          }
                }, [
                  _createVNode(_component_Icon, {
                    name: "up",
                    sm: ""
                  }),
                  _createVNode(_component_t, { path: "symbol_22" }, {
                    default: _withId(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }),
                  _createVNode("span", _hoisted_4, _toDisplayString(buy), 1)
                ], 8, ["onClick"])
              ]),
              _: 2
            }, 1032, ["to"]),
            _createVNode(_component_router_link, {
              to: `/create/${_ctx.symbol && _ctx.symbol.code}/1`,
              custom: ""
            }, {
              default: _withId(({navigate}) => [
                _createVNode("button", {
                  class: "btn flex-2 danger ml-16",
                  onClick: () => {
            if (_ctx.product?.specs?.length === 1 || !_ctx.getSpeedAc('uuid')) {
              navigate()
            } else {
              _ctx.clickAlert()
            }
          }
                }, [
                  _createVNode(_component_Icon, {
                    name: "down",
                    sm: ""
                  }),
                  _createVNode(_component_t, { path: "symbol_23" }, {
                    default: _withId(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }),
                  _createVNode("span", _hoisted_6, _toDisplayString(price), 1)
                ], 8, ["onClick"])
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        }, 8, ["symbol"])
      ])
    ]),
    _: 1
  }))
})